import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import { Session } from 'services';
import httpClient from 'utils/httpClient';

const ANNOUNCE_STUDENT = (id: number) =>
  `/v2/teacher/unit/${id}/remind-student-checkin`;

export type AnnounceStudentBody = {
  id: number;
};

export type AnnounceStudentResponse = {
  session: Session;
};

export const announceStudent = ({ id }: AnnounceStudentBody) => {
  return httpClient.post<AnnounceStudentResponse>(ANNOUNCE_STUDENT(id), {});
};

export const useAnnounceStudent = (
  opts?: UseMutationOptions<
    AxiosResponse<AnnounceStudentResponse>,
    AxiosError<any>,
    AnnounceStudentBody
  >,
) =>
  useMutation<
    AxiosResponse<AnnounceStudentResponse>,
    AxiosError<any>,
    AnnounceStudentBody
  >(announceStudent, opts);
